<template>
  <b-button @click="$emit('click', $event)" :size=size variant="secondary" v-b-tooltip.hover :title="showToolTip ? 'Обновить' : ''">
    <transition name="ani_fade">
      <i v-if="showAnimate || !animate" class="fa fa-refresh"></i>
    </transition>
  </b-button>
</template>

<script>

export default ({
  name: "button-refresh",

  props: {
    animate: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: "sm"
    }
  },

  data: () => {
    return {
      showAnimate: true,
      timerId: null
    }
  },

  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  },

  watch: {
    animate(newValue) {
      if (newValue) {
        this.timerId = setInterval(() => {
          this.showAnimate = !this.showAnimate
        }, 500);
      }
      else {
        if (this.timerId) {
          clearInterval(this.timerId)
        }
      }
    }
  },

})
</script>

<style>
  .ani_fade-enter-active, .ani_fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .ani_fade-enter-from, .ani_fade-leave-to {
    opacity: 0;
  }
</style>